import React, { useState } from 'react';

function AntenneMap({ address }) {
    const [loading, setLoading] = useState(true); // État pour gérer le chargement

    if (!address) {
        return <p>Adresse non disponible pour cette antenne.</p>;
    }

    // Génère une URL Google Maps Embed pour afficher la carte
    const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

    return (
        <div className="map-container position-relative">
            {loading && (
                <div className="map-loader-overlay">
                    <div className="map-loader"></div>
                </div>
            )}
            <iframe
                src={mapSrc}
                title="Carte de l'antenne"
                onLoad={() => setLoading(false)} // Cache le loader une fois la carte chargée
                style={{
                    width: '100%',
                    height: '300px',
                    border: '0',
                    borderRadius: '8px',
                }}
                allowFullScreen
                loading="lazy"
            ></iframe>
        </div>
    );
}

export default AntenneMap;
